// extracted by mini-css-extract-plugin
module.exports = {"collapsedPayment":"_1vb1c","iconWrapper":"_1pAf-","creditCardNetworkIcon":"Wf953"};